'use client';

import { __spreadArray } from '../_virtual/_tslib.js';
import { ELanguage } from '../Utils/constants.js';

/**
 * Get sub-level list from parent Id
 * @param parentId Parent Id in string
 * @param list Parent List. It should be look like districtData from app-shell-v2 (initialDataProvider)
 * @returns List of sub-level list from parent
 */
var getChildrenListByParentId = function (parentId, list) {
    var keyList = Object.keys(list);
    var valueList = Object.values(list);
    var index = keyList.indexOf(parentId.toString());
    if (!valueList[index]) {
        return [];
    }
    return __spreadArray([], valueList[index], true);
};
var sortOptionsAlphabet = function (options, isSortAlphabet) {
    if (!isSortAlphabet) {
        return options;
    }
    var removedItem = null;
    var filteredHaveAllItem = options.filter(function (item) { return item.id === -1; });
    if (filteredHaveAllItem.length > 0) {
        removedItem = options.splice(0, 1);
    }
    options.sort(function (itemA, itemB) {
        if (itemA.name < itemB.name) {
            return -1;
        }
        if (itemA.name > itemB.name) {
            return 1;
        }
        return 0;
    });
    if (removedItem !== null) {
        return __spreadArray(__spreadArray([], removedItem, true), options, true);
    }
    return options;
};
var sortChildOptionAlphabet = function (options, langCode, isSortAlphabet) {
    if (!isSortAlphabet) {
        return options;
    }
    var returnValue = {};
    var values = Object.values(options);
    /**
     * TODO: Find a more effective solution to resolve this problem without using unshift.
     * The 'childrenList' starts with an ID of 1, whereas the array starts at 0.
     * This misalignment is causing a shift of one item.
     */
    values.unshift([]);
    var newValues = values.map(function (item) {
        return item.sort(function (itemA, itemB) {
            if (langCode === ELanguage.VI) {
                if (itemA.name < itemB.name) {
                    return -1;
                }
                if (itemA.name > itemB.name) {
                    return 1;
                }
            }
            else {
                if (itemA.nameEn < itemB.nameEn) {
                    return -1;
                }
                if (itemA.nameEn > itemB.nameEn) {
                    return 1;
                }
            }
            return 0;
        });
    });
    Object.assign(returnValue, newValues);
    return returnValue;
};
/**
 * Completely deep clone array
 * @param arr any array value (Only Primitive accepted)
 * @returns new deep cloned value
 */
function deepCloneArray(arr) {
    var clone = [];
    for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
        var element = arr_1[_i];
        if (Array.isArray(element)) {
            clone.push(deepCloneArray(element));
        }
        else if (typeof element === 'object' && element !== null) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            clone.push(deepCloneObject(element));
        }
        else {
            clone.push(element);
        }
    }
    return clone;
}
/**
 * Completely deep clone object (Alternative with  )
 * @param arr any array value (Only Primitive accepted)
 * @returns new deep cloned value
 */
function deepCloneObject(obj) {
    var clone = {};
    for (var key in obj) {
        if (Array.isArray(obj[key])) {
            clone[key] = deepCloneArray(obj[key]);
        }
        else if (typeof obj[key] === 'object' && obj[key] !== null) {
            clone[key] = deepCloneObject(obj[key]);
        }
        else {
            clone[key] = obj[key];
        }
    }
    return clone;
}

export { deepCloneArray, deepCloneObject, getChildrenListByParentId, sortChildOptionAlphabet, sortOptionsAlphabet };
//# sourceMappingURL=helpers.js.map
